/** @format */

import {gql} from '@apollo/client';

export const GET_SUSPENDED_RECOMMENDATIONS = gql`
  query GetSuspendedRecommendations {
    currentUser {
      currentCompany {
        recommendationSuspendeds {
          id
          sensorName
          suspendedUntil
        }
      }
    }
  }
`;

export const GET_RECOMMENDATIONS = gql`
  query GetRecommendations {
    currentUser {
      currentCompany {
        lastRecommendations {
          checks
          found
          id
          sensor {
            name
            isPaused
          }
          new
        }
      }
    }
  }
`;
